<template lang="pug">
.register-row.form-label
  .register-group
    .register-key
      span.key-name 施設での食事
    .register-value
      OutingDetailNeedsMealsTable(v-model="value" :fields="fields")
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import OutingDetailNeedsMealsTable, { OutingDetailNeedsMealsTableItem, OutingDetailNeedsMealsTableField } from "@/pc/containers/outings/OutingDetailNeedsMealsTable.vue";

/**
 * ### 外出外泊届け詳細 食事キャンセルコンポーネント
 */
@Component({
  components: {
    OutingDetailNeedsMealsTable
  }
})
export default class OutingDetailNeedsMeal extends Vue {
  /** 1行あたりの情報配列 */
  @Prop({ required: true })
  value!: Array<OutingDetailNeedsMealsTableItem>;
  /** 列名配列 */
  @Prop({ required: true })
  fields!: Array<OutingDetailNeedsMealsTableField>;
}
</script>
